import nightmodeSubject from './subject'

import { setStateIsNight } from './lib/storage'

nightmodeSubject.subscribe({
  next: setStateIsNight,
})
